const cards = [
  {
    link: "/cloths",
    label: "Ткани",
    icon: "fa-user",
  },
  {
    link: "/products",
    label: "Продукты",
    icon: "fa-user",
  },
  {
    link: "/cut_of_clothes",
    label: "Крой",
    icon: "fa-user",
  },
  {
    link: "/sewing_accessories",
    label: "Фурнитура",
    icon: "fa-user",
  },
  {
    link: "/stationery",
    label: "Канцелярия",
    icon: "fa-user",
  },
  {
    link: "/expendable_materials",
    label: "Расходники",
    icon: "fa-user",
  },
  {
    link: "/packages",
    label: "Упаковки",
    icon: "fa-user",
  },
  {
    link: "/promotional_products",
    label: "Рекламная продукция",
    icon: "fa-user",
  },
  {
    link: "/users",
    label: "Пользователи",
    icon: "fa-group",
    onlyVipRoles: true,
  },
  {
    link: "/login_history",
    label: "История входов",
    icon: "fa-history",
    onlyVipRoles: true,
  },
];

export const mainPage = {
  cards,
};



// WEBPACK FOOTER //
// ./src/user/constants/mainPage.js